import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import { Button } from "@mui/material";
import axios from 'axios';
// const querystring = require('querystring');

export default class CreateVCSVersion extends Component {

	constructor(props)
	{
		console.log(props);
    super(props);
  }

  state = {
    vcsVersionObjects : []
  };

	componentDidMount() 
	{
		this.handleOnLoad();
	}

	handleOnLoad = () => {
      axios.get(`http://os-dev.origosoftware.com:3000/vcs-version/`).then(res => {
      const vcsVersions = res.data;
      console.log(vcsVersions);
      this.setState({ vcsVersions });
      console.log(res.data[0]);
		});
		
	}
	
	render(){
    return (
	<form>
		<div class="container-fluid">
		<div style={{display: "flex", justifyContent: "space-between"}}>
			<h4>Create A Revision </h4>
			  <div>
			  <Link to="/waves">
			  	<Button variant="contained">Go Back</Button>
			  </Link>
			  </div>
		</div>
		<hr />
		<label class="ContentTitle" value=" #{userSession.currentContentObject._content_name }">Create a Revision for (File/Content Object Name/Alias)</label>

				<div class="form-group row">
				<label class="ContentTitle col-sm-2">Version Label</label>
				<input class="form-control input-xlarge col-sm-8" value="#{ombVcsVersionForm.createVcsVersion.versionLabel }" id="label"></input>
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2" value="#{userSession.currentContentObject._content_image_file}">Document Name</label>
				<input class="form-control input-xlarge col-sm-8" id="documentName" value="#{ombVcsVersionForm.createVcsVersion.documentName }"></input>
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2">Description</label>
				<input class="form-control input-xlarge col-sm-8" id="description" value="#{ombVcsVersionForm.crerateVcsVersion.description }"></input>
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2">Current Disposition</label>
				<input class="form-control input-xlarge col-sm-8" id="currentDisposition" value="#{ombVcsVersionForm.createVcsVersion.currentDisposition }"/>
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2">Current Disposition User</label>
				<input class="form-control input-xlarge col-sm-8" readonly="true" id="currentDispositionUserId" value="#{ombVcsVersionForm.createVcsVersion.currentDispositionUserid }"/>
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2">Current Disposition Date(mm/dd/yyyy)</label>
				<input class="form-control input-xlarge date-picker col-sm-8" id="currentDispositionTimestamp" value="#{ombVcsVersionForm.createVcsVersion.currentDispositionTimestamp }">
				</input>
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2">Current Disposition Exp Date(mm/dd/yyyy)</label>
				<input class="form-control input-xlarge date-picker col-sm-8" id="currentDispositionExpTimestamp" value="#{ombVcsVersionForm.createVcsVersion.currentDispositionExpTs }">
				</input>
				</div>
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2">Revision Number</label>
				<input class="form-control input-xlarge col-sm-8" id="revisionNumber" value="#{ombVcsVersionForm.createVcsVersion.revisionNumber }"/>
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2">Lock</label>
				<input type="checkbox" value="1" id="checkbox1"/>
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2">Lock User</label>
				<input class="form-control input-xlarge col-sm-8" readonly="true" id="lockUserId" value="#{ombVcsVersionForm.createVcsVersion.lockUserid }"/>
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2">Lock Date(mm/dd/yyyy)</label>
				<input class="form-control input-xlarge date-picker col-sm-8" id="lockTimestamp" value="#{ombVcsVersionForm.createVcsVersion.lockTimestamp }"/>
				</div>
			<hr />
			<div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2">Last CheckIn User</label>
				<input class="form-control input-xlarge col-sm-8" readonly="true" id="lastCheckInUserId" value="#{ombVcsVersionForm.createVcsVersion.lastCheckinUserid }"/>
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2">Last CheckIn Date(mm/dd/yyyy)</label>
				<input class="form-control input-xlarge date-picker col-sm-8" readonly="true" id="lastCheckInTimestamp" value="#{ombVcsVersionForm.createVcsVersion.lastCheckinTimestamp }">
				</input>
			</div>			

			<hr/>
			<button class="btn  btn-success" value="Revision" actionListener="saveVCSObject()">Save Revision</button>
		
		</div>
	</form>
);
}
}